import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TldOfferWidgetLayout } from '../tldOfferWidget.layout';
export const storefrontLayout = {
  ...TldOfferWidgetLayout,
  StripContainer: props => /*#__PURE__*/React.createElement(TldOfferWidgetLayout.StripContainer, _extends({
    backgroundColor: "var(--wds-color-fill-surface-stage)",
    marginTop: "0"
  }, props)),
  CarouselStripContainer: props => /*#__PURE__*/React.createElement(TldOfferWidgetLayout.CarouselStripContainer, _extends({
    backgroundColor: "var(--wds-color-fill-surface-stage)",
    marginTop: "0"
  }, props))
};
//# sourceMappingURL=storefront.layout.js.map